import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import OneButtonModalFooter from "components/modals/OneButtonModalFooter";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { CostUnitWarningItem, CostUnitWarningProps } from "types/modals";

import "components/listWithActions/list_gaia.scss";

const CostUnitWarning = ({
    more,
    closeModal,
    loopFocus,
    initialFocusRef,
}: CostUnitWarningProps): React.ReactElement => {
    const { translate } = useTranslation();
    const warnings = more?.warnings ?? [];

    return (
        <>
            <div className="ga-modal__content">
                <div className="actions-list" id="warning-grid">
                    <div className="row header-row mx-0">
                        <div className="col-md-6">
                            {translate("popUp.costUnitWarning.costUnit")}
                        </div>
                        <div className="col-md-6">
                            {translate("popUp.costUnitWarning.warning")}
                        </div>
                    </div>
                    <div className="main-panel radius-4">
                        {warnings.map((item: CostUnitWarningItem, index: number) => {
                            const costUnit = `${item.dimensionName} (${item.dimensionNumber}): ${item.number} (${item.name})`;
                            return (
                                <div className="row mx-0" key={index}>
                                    <div className="col-md-6">{costUnit}</div>
                                    <div className="col-md-6 warning">
                                        {translate("popUp.costUnitWarning.noLongerAvailable")}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <OneButtonModalFooter
                tabIndex={MODAL_CONTENT_TAB_INDEX}
                enabled={true}
                callback={closeModal}
                text={translate("popUp.close")}
                loopFocus={loopFocus}
                buttonRef={initialFocusRef}
            />
        </>
    );
};

export default CostUnitWarning;
